import _objectSpread from "E:\\Workspaces\\VScode\\vue3+TS\\vue\u6848\u4F8B\\cloudMusicProject-master\\node_modules\\@babel\\runtime\\helpers\\esm\\objectSpread2.js";
import { defineComponent, reactive, ref } from "vue";
import { useState } from "@/hooks/mapGet/index.js";
import { useStore } from "vuex";
import { changeTag } from "@/hooks/tagCate";
import HeadNav from "./cpns/headNav.vue";
import TagNav from "./cpns/tagNav.vue";
import NewMusic from "./cpns/newMusic.vue";
import NewDisc from "./cpns/newDisc.vue";
import Iscroll from "@/baseui/infiniteScroll/infiniteScroll.vue";
export default defineComponent({
  name: "LatestMusic",
  setup: function setup() {
    var store = useStore();
    var state = useState("Latest", ["newMusicList", "newDiscList"]);
    /* 切换页面 */

    var isShow = ref(true);
    /* 记录滚动添加数 */

    var loadNum = ref(20);
    store.dispatch("Latest/getNewMusicList"); //默认请求新歌速递

    var setType = reactive([0, "ALL"]);
    var refTagNav = ref(TagNav);
    /* 新歌速递标签导航 */

    var tagNav = reactive([{
      id: 0,
      title: "全部"
    }, {
      id: 7,
      title: "华语"
    }, {
      id: 96,
      title: "欧美"
    }, {
      id: 8,
      title: "日本"
    }, {
      id: 16,
      title: "韩国"
    }]);
    /* 新碟上架标签导航 */

    var tagNav2 = reactive([{
      id: "ALL",
      title: "全部"
    }, {
      id: "ZH",
      title: "华语"
    }, {
      id: "EA",
      title: "欧美"
    }, {
      id: "JP",
      title: "日本"
    }, {
      id: "KR",
      title: "韩国"
    }]);
    /* 新碟上架请求数据 */

    var discResInfo = reactive({
      area: "ALL",
      type: "new",
      limit: 20,
      offset: 0
    });
    /* 顶部导航切换事件 */

    var navChange = function navChange(navTitle) {
      loadNum.value = 20;

      if (navTitle == "新碟上架") {
        store.dispatch("Latest/getNewDiscList", discResInfo);
      }

      isShow.value = navTitle == "新歌速递" ? true : false;
      refTagNav.value.isTitle = isShow.value ? setType[0] : setType[1];
    };
    /* 标签点击事件 */


    var tagChangeClick = function tagChangeClick(area, type) {
      loadNum.value = 20;
      /* 请求新碟上架数据 */

      if (typeof area == "string" && type) {
        var arr = [area, type];
        state.newDiscList.value.length = 0;
        discResInfo.area = area;
        discResInfo.type = type;
        changeTag(function () {
          return store.dispatch("Latest/getNewDiscList", discResInfo);
        }, arr, 700);
        setType[1] = area;
      }
      /* 请求新歌速递数据 */


      if (typeof area == "number") {
        state.newMusicList.value.length = 0; //请求防抖

        changeTag(function () {
          return store.dispatch("Latest/getNewMusicList", area);
        }, area, 700);
        setType[0] = area;
      }
    };
    /* 全部和热门点击事件 */


    var rightTagClick = function rightTagClick(area, type) {
      loadNum.value = 20;
      tagChangeClick(area, type);
    };
    /* 每次滚动，获取10条数据 */


    var scrollLoad = function scrollLoad() {
      loadNum.value += 10;
    };

    return _objectSpread(_objectSpread({
      isShow: isShow,
      refTagNav: refTagNav
    }, state), {}, {
      loadNum: loadNum,
      tagNav: tagNav,
      tagNav2: tagNav2,
      navChange: navChange,
      tagChangeClick: tagChangeClick,
      rightTagClick: rightTagClick,
      scrollLoad: scrollLoad
    });
  },
  components: {
    HeadNav: HeadNav,
    TagNav: TagNav,
    NewMusic: NewMusic,
    NewDisc: NewDisc,
    Iscroll: Iscroll
  }
});